/** @file pitchRelative: a node's pitch as the profile camera would see it, wrapped to [-180, 180). */

/** `nodePitchDeg + deltaDeg` wrapped into [-180, 180) (decision 11). */
export function pitchRelative(nodePitchDeg: number, deltaDeg: number): number {
  const r = (nodePitchDeg + deltaDeg + 180) % 360;
  return (r < 0 ? r + 360 : r) - 180;
}
